import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { DeliveryActions } from './delivery.actions';

@Injectable({
  providedIn: 'root'
})
export class DeliveryEffects {
  sendDeliveryEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendDeliveryEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(DeliveryActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
